export const STYLES = {
  font: {
    common:
      'color: #465179; font-family: Roboto; font-size: 1.2rem; line-height: 115%;',
    bold: 'font-weight: 600;',
    normal: 'font-weight: 400;',
  },
  div: {
    flex: 'display: flex;',
    alignCenter: 'align-items: baseline;',
    flexBetween: 'display: flex; justify-content: space-between;',
  },
  title: {
    textLeft: 'text-align: left; margin: 0;',
  },
  width(val: number) {
    return `width: ${val}px;`;
  },
  height(val: number) {
    return `height: ${val}px;`;
  },
  gap(val: number) {
    return `gap: ${val}px;`;
  },
  borderRadius(val: number) {
    return `border-radius: ${val}px;`;
  },
  marginBottom(val: number) {
    return `margin-bottom: ${val}px;`;
  },
};

export const PAYMENTS_DATASETS_LABELS = [
  'PAYMENT_LINK',
  'QR_PAY',
  'RECCURRENT_PAY',
  'SITE_PAY',
  'COMMISSION',
];

export const RETURNS_DATASETS_LABELS = [
  'P2P_OPERATION',
  'TRANSITION_OPERATION',
  'EXTERNAL_OPERATION',
];

export const WEEK_DATE_LABELS = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];

export const YEAR_DATE_LABELS = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];
